export const SupportContactsModalConst = {
  defaultData: {
    title: 'What type of support are you looking for?',
    desc: 'What do you need help with?',
  },
  technicalIssue: {
    title: 'IT Support',
    desc: 'Contact the IT Service Desk using any of the options below. For fastest resolution, use Chat or call the number for your region.',
  },
  axiomAnswers: {
    title: 'Axiom Answers',
    desc: 'Send us an email and the team will get back to you.',
  },
  peopleAtAxiom: {
    title: 'People At Axiom',
    desc: 'Please reach out to PAX for anything relating to your employment contract or benefits such as healthcare and PTO allowance, and general HR questions and escalations.',
  },
  oppFeedQuestion: {
    title: 'Opportunity Feed',
    desc: null,
  },
  profileHelp: {
    title: 'Profile Help',
    desc: 'Your Talent Success Partner is your go-to for profile guidance and questions about working with Axiom.',
  },
  somethingElse: {
    title: 'Contact Your Team',
    desc: null,
  },
};

export const RegionalPhoneNumbers = [
  { region: 'US & Canada', number: '+1 855 233 6730' },
  { region: 'Australia', number: '+61 1800 960 701' },
  { region: 'London', number: '+44 207 324 8093' },
  { region: 'Hong Kong', number: '+852 2495 1137' },
  { region: 'Singapore', number: '+65 6668 7128' },
];

export const OppFeedAccordionData = [
  {
    label: 'What is Opportunity Feed?',
    desc: 'Opportunity Feed is a curated view of potential client engagements that Axiom has made visible to eligible talent to increase our transparency about the type of work we’re competing for. You can browse open opportunities and submit an Expression of Interest (EOI) for roles that match your background and availability. Some Opportunities will never be posted to the feed (such as when client needs are confidential), and not all Opportunities will open for Expressions of Interest.',
  },
  {
    label: 'What is an Expression of Interest (EOI)?',
    desc: "An EOI lets you signal to Axiom's team that you'd like to be considered for a specific opportunity. It's not a direct application - our team reviews all EOIs alongside your full profile to determine the best match for the client.",
  },
  {
    label: 'How competitive are opportunities on the Feed?',
    desc: 'On average, each opportunity receives 27 Expressions of Interest. Because of this volume, our team is not able to provide individual status updates or confirm receipt of specific EOIs. We review all submissions carefully.',
  },
  {
    label:
      'Can my Talent Success Partner submit me for a specific opportunity?',
    desc: "No. Your Talent Success Partner manages only a small number of opportunities on the Feed and has no visibility into most of what you see. For similar reasons, your Talent Success Partner won't be able to help with status updates for specific EOIs.",
  },
  {
    label: "Why haven't I heard back about my EOI?",
    desc: "If you haven't heard back, it's likely we've submitted other talent but haven't yet received a response from the client - meaning you may still be considered if the client requests additional talent. Additional submissions only happen when a client requests different talent to consider.",
  },
  {
    label: 'How do I improve my chances of being matched?',
    desc: "Keep in mind that Opportunity Feed is primarily a visibility tool - it's designed to give you a sense of the types of engagements Axiom runs. You're not expected to submit an Expression of Interest on every opportunity, or at all. That said, a complete, up-to-date profile makes a real difference. Focus on your experience descriptions, skills, and preferred weekly hours. A well-written 'Why you're a good fit' comment when submitting an EOI also increases your chances of being submitted to a client.",
  },
];
